/**
 * Конфиг с настройками Axios обращения к API сервера
 */

import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import qs from 'qs';

import getClearParams from './utils/getClearParams';
import apiConstants from './constants/apiConstants';
import LocalStorageService from './services/LocalStorageService';
import UsersService from './services/UsersService';

/**
 * Base url для проксирования запросов на сервер
 */
axios.defaults.baseURL = apiConstants.prefix;

axios.defaults.paramsSerializer = (params: any) => {
  const clearParams = getClearParams(params);

  return qs.stringify(clearParams, { arrayFormat: 'repeat' });
};

axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const { accessToken, tokenType = 'Bearer' } = LocalStorageService.getToken();

  const authValue = `${tokenType} ${accessToken}`;
  config.headers.set('Authorization', authValue);

  return config;
});

axios.interceptors.response.use(
  response => response,
  async (error: AxiosError) => {
    const originalRequest: any = error.config || {};

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const { refreshToken } = LocalStorageService.getToken();

      if (refreshToken) {
        try {
          const { data } = await UsersService.getRefreshedToken(refreshToken);
          LocalStorageService.setToken(data);
        } catch {
          LocalStorageService.clearToken();
          window.location.reload();
          return Promise.reject(error);
        }
        return axios(originalRequest);
      }
    }
    if (error.response?.status === 402) {
      LocalStorageService.clearToken();
    }

    return Promise.reject(error);
  }
);
